import * as THREE from "three";
import React, { useState, useMemo, useEffect, useRef } from "react";
import Loader from "../util/loader.js";
import useStore from "../store";
import { useFrame, useUpdate } from "react-three-fiber";
import { sphericalToCartesian } from "../util/position";

function Model({ url, position, rotation, scale }) {
  const { globeRadius, enableShadows } = useStore((state) => state.mutation);
  const visualizerArray = useStore((state) => state.visualizerArray);
  const [obj, set] = useState();
  const ref = useRef();

  const surfaceMaterial = new THREE.MeshStandardMaterial({
    side: THREE.DoubleSide,
    alphaTest: 0.0,
    color: new THREE.Color(1, 1, 1),
  });


  const lightMaterial = new THREE.MeshBasicMaterial({
    side: THREE.DoubleSide,
    alphaTest: 0.5,
    color: "hsl(0.16, 100%, 65%)", // (can also use a CSS color string here)
  });

  useFrame(() => {
    let sum = 0;
    if (visualizerArray != null) {
      sum = visualizerArray.reduce((a, b) => a + b, 0);
    }

    const value = sum / 60 / 100;
    lightMaterial.color.setHSL(0.16, 1, 0.3 + value);
  });

  useMemo(
    () =>
      Loader.getInstance()
        .getLoader()
        .load("/models/gltf/" + url, set),
    [url]
  );

  if (!obj) return null;

  // TODO: prevent this from being traversed so many times, maybe can use instanced material
  obj.scene.traverse((o) => {
    if (o.isMesh) {

      o.castShadow = enableShadows;
      if (o.name.includes("Light1")) {
        o.material = lightMaterial;
      } else {
        o.material = surfaceMaterial;
      }
    }
  });

  // TODO: move this outside of this
  // code for having objects face center of globe
  // obj.scene.lookAt(new THREE.Vector3(0, 0, 0));


  const p = sphericalToCartesian(globeRadius, position.phi, position.theta);

  return (
    <object3D ref={ref} rotation={[0, 0, 0]}>
      <primitive
        scale={scale}
        position={[p.x, p.y, p.z]}
        // rotation={rotation}
        rotation={[position.phi + rotation[0], rotation[1], rotation[2]]}
        object={obj.scene}
      />
    </object3D>
  );
}

export default Model;
